import { get } from "lodash"
import { IsoDate } from "helpers/types/dates"
import { SelectedIndex } from "helpers/types/instruments/selected"
import { OkReduxDataResult } from "model/state"
import { CompositionByNode, getCompositionType } from "./composition"
import { PositionSetMetadata } from "./types"

interface IndexData {
  model: {
    security: {
      availability: {
        to: IsoDate
        from: IsoDate
      }
      descriptors: {
        name: string
        hasComposition: boolean
      }
    }
    simulation: {
      composition: [{
        compositionBy: CompositionByNode
      }]
    }
  }
}

export interface IndexMetadata extends PositionSetMetadata {
  type: "INDEX"
  ticker: string
  hasComposition: boolean
}

const INDEX_QUERY = `query ($modelId: String!, $indexId: String!, $currentDate: Date!, $segment: Segment) {
  model (id: $modelId) {
    security (indexId: $indexId) {
      availability {
        to
        from
      }
      descriptors (on: $currentDate) {
        name
        hasComposition
      }
    }
    simulation (positionSet: {
      type: INDEX,
      id: $indexId,
      segment: $segment
    }, from: $currentDate, to: $currentDate) {
      composition {
        compositionBy (groupBy: LONG_SHORT) {
          id
        }
      }
    }
  }
}`

function indexSelect(data: OkReduxDataResult<IndexData>, indexId: string): IndexMetadata {
  return {
    type: "INDEX",
    name: get(data, "data.model.security.descriptors.name"),
    earliestDate: get(data, "data.model.security.availability.from"),
    latestDate: get(data, "data.model.security.availability.to"),
    // [TODO]
    unavailable: get(data, "data.model.security.availability") === null,
    hasComposition: get(data, "data.model.security.descriptors.hasComposition"),
    ticker: indexId,
    compositionType: getCompositionType(data),
  }
}

export function getIndexQueryDefinition(positionSet: SelectedIndex, modelId: string, currentDate: IsoDate) {
  const variables = { modelId, currentDate, indexId: positionSet.id, segment: positionSet.segment }

  return {
    query: INDEX_QUERY,
    variables,
    queryKey: ["position-set", "metadata", "index", variables],
    select: (data: OkReduxDataResult<IndexData>) => indexSelect(data, positionSet.id),
  }
}
